import React from "react";
import { TROPHY_SVG } from "../../../utils/svgs";
import { AppIcon } from "../../Generic/AppIcon";

const CaregiverSurveyTrophyHeader = () => {
  return (
    <div className="CaregiverSurveyTrophyHeader">
      <div className="trophyBow" />
      <AppIcon className="trophy" icon={TROPHY_SVG} style={{ width: 35, height: 48 }} />
    </div>
  );
};

export default React.memo(CaregiverSurveyTrophyHeader);
